<template> 	
	<footer class="foot">
		<p class="p1">24小时客服热线</p>
		<p class="p2"><a href="tel:852-3758 2228"></a> 852-3758 2228 (香港)</a></p>
		<p class="line"></p>
		<p class="p3">免责声明   |   隐私条款   <!-- |   <b class="appTxt" @click="js_app()">APP相关</b> --></p>
		<p class="p3">Copyright © 2026金盛贵金属有限公司版权所有，不得转载</p>
		<!-- <p class="p3">ICP许可证号：晋ICP备2020009056号</p>   -->
		 <p class="p3">	 
		温馨提示： 投资有风险，入市需谨慎，最终收益以实际为准
	 	</p> 
     <!-- <p class="p3">	
		APP开发者：香港金盛贵金属有限公司<br>
		APP名称： 金盛贵金属  应用版本：3.3.3<br>
		应用权限：<b class="mlr" @click="js_yingyong()">查看权限</b>隐私政策：<b class="mlr" @click="js_yingsi()">查看政策</b><br>
		用户协议：<b class="mlr" @click="js_xieyi()">查看协议</b>
		更新时间；2021年1月25日<br>
		温馨提示： 投资有风险，入市需谨慎，最终收益以实际为准
	 	</p>  -->
 
	 <section class="mask" v-show="yingyong">
	    <div class="content">
	        <div class="topTitles"> 应用权限说明</div> 
	        <span class="close js_close" @click="js_yingyong()"> × </span>  
	        <div class="scroll">
	         <p>1、允许该应用通过全球定位系统(GPS)或网络位置信息源(例如基站和WLAN)获取您的精确位置信息。您必须在设备上开启这些位置信息服务，应用才能获得位置信息。应用会使用此类服务确定您的位置，这可能会消耗更多电量。</p>
	         <p>2、允许该应用获取您的大致位置信息。这类位置信息来自于使用网络位置信息源(例如基站和WLAN)的位置信息服务。您必须在设备上开启这些位置信息服务，应用才能获得位置信息。应用会使用此类服务确定您的大概位置。</p>
	         <p>3、允许该应用使用麦克风录制音频。此权限可让该应用不经您的确认即可随时录制音频。</p>
	         <p>4、该应用访问设备的电话功能。此权限可让该应用确定本机号码和设备ID、是否正处于通话状态以及拨打的号码。</p>
	         <p>5、允许该应用读取存储卡中的内容。</p>
	         <p>6、允许该应用使用相机拍摄照片和视频。此权限可让该应用随时使用相机，而无需您确认。</p>
	         <p>7、允许该应用写入SD卡。</p>
	         <p>8、允许该应用访问后台位置，该权限仅会影响应用在后台运行时对位置信息的访问权限。常规权限允许访问网络允许该应用访问网络连接，可能产生GPRS流量。</p>
	         <p>9、允许该应用更改网络连接的状态。</p>
	         <p>10、允许该应用创建网络套接字和使用自定义网络协议。浏览器和其他某些应用提供了向互联网发送数据的途径，因此应用无需该权限即可向互联网发送数据。</p>
	         <p>11、允许该应用读写系统的设置数据。恶意应用可能会破坏您的系统配置。</p>
	         <p>12、允许该应用请求安装文件包。</p>
	         <p>13、允许该应用使用其他的位置信息提供程序命令。此权限使该应用可以干扰GPS或其他位置信息源的运作。</p>
	         <p>14、允许该应用修改全局音频设置，例如音量和用于输出的扬声器。</p>
	         <p>15、允许该应用阻止手机进入休眠状态。</p>
	         </div>
	    </div>
	</section>
	<section class="mask" v-if="yingsi">
	    <div class="content">
	        <div class="topTitles"> 隐私政策</div> 
	        <span class="close js_close" @click="js_yingsi()"> × </span>  
	         <div class="scroll">
	        <p class="incent">香港金盛贵金属有限公司（下称“交易商”）根据《个人资料(隐私条例》来保护客户的个人资料隐私。在交易商使用客户资料以提供其最佳之服务时，亦会高度关注对于客户资料使用之安排。交易商会根据香港特别行政区法例《个人资料(隐私)条例》之规定，力求完全符合个人资料保证要求。为此，交易商会确保其雇员遵守法例规定的保安和保密严谨标准。</p>
	        <p>1、为保障客户正常使用服务，维护服务的正常运行，改进及优化服务体验以及保障账户安全，可能需要客户授权使用如下个人权限：
	        实名认证：确保客户信息准确无误；相机/相册：发送图片，选取图片上传，存储照片，扫一扫，用于反馈意见和个人信息审核时使用； 银行卡识别：为保障客户资金安全，需进行银行卡审核； 用户地址：主要用于发放实物奖励。</p>
	        <p>2、交易商收集的各项个人资料，只供应业务运作及其他有关活动之用。</p>
	        <p>3、关于使用Cookies技术：交易商可能会在客户及存款交易商的电脑设定cookies，可能会于交易商的产品和服务中使用cookies来分析客户在交易商网站的浏览行为，以协助交易商更好的了解客户需求及提供更好的服务方式，但对于收集得来和共用的资料是不具姓名及无法被个别识别的。</p>
	        <p>4、信息储存：交易商会按照法律法规规定，将收集的用户信息存储于中国香港服务器。一般而言，我们仅为实现对客服务所必需的时间保留客户的用户信息。</p>
	        <p>5、信息安全保护：交易商致力于使用防火墙、密码和个人身份证号码认证系统和操控机制来控制未授权的系统进入和存储资料，或使用其他资料保障工具确保网站安全及符合业界标准。</p>
	        <p>6、交易商不会将客户个人资料用于用户画像、个性化展示，也不会收集关于您设备上安装的其他APP信息。交易商使用客户的用户信息，超出了与收集时声称的目的及具有直接或合理关联的范围，将会在使用用户信息前，再次告知并征求客户的明示同意（通过主动点击“确认”做出直接性动作） 。</p>
	        <p>7、交易商会将客户个人资料保密储存，防止其个人资料被盗用，未达到隐私保护之最佳效果，除符合本款第五、第七条之规定外，客户充分理解交易商不会向客户本人以外的任何主体提供客户的资料、信息，即使该主体声称其为授权。</p>
	         </div>
	    </div>
	</section> 
	<section class="mask" v-if="xieyi">
	    <div class="content">
	        <div class="topTitles"> 隐私政策</div> 
	        <span class="close js_close" @click="js_xieyi()"> × </span>  
	         <div class="scroll">
				 <div>
        <h2>香港金盛贵金属有限公司<br>
          GOLDAY PRECIOUS METALS CO. LIMITED<br>
          客户协议书<br>
          CLIENT AGREEMENT<br>
          (适用于MT4 及M-FINANCE 账户)<br>
          <br>
          客户须知
        </h2>
        <p class="fxpl">*风险披露声明*<br>
          此声明并不披露关于贵金属（黄金及白银）的所有风险及其它重要事项。鉴于有关风险，客户在开始进行贵金属交易之前，应该清楚了解有关交易性质和风险程度，并知悉贵金属交易并不适合一般投资者。客户必须根据其个人的投资经验、目的、财政状况和风险承受能力等相关因素仔细考虑贵金属交易是否适合客户本人。客户在开户及开始交易前应该咨询法律及其它独立的专业意见。
        </p>
        <h3>贵金属交易所带来的风险</h3>
        <strong>1.杠杆式效应</strong>
        <p>
          贵金属交易带有相当高的风险。此类交易属于杠杆式交易，意指透过杠杆比例，藉以让客户可以极低的初始保证金来控制金额极高的交易合约。即使市场上出现任何变动也会对客户已经或将要存入的资金造成极大的影响，这对客户也许有好的影响也有可能是坏的影响。客户可能会为了保持客户的头寸，而在客户存入本公司的初始保证金及任何追加资金上承受损失。如果市场变动对客户不利或者保证金水平提高，客户有机会未能及时追加保证金来维持客户的头寸而在亏损的情况下被强制平仓，客户将必须对由此造成的亏损负责。
        </p>
        <strong>2.减少风险的指令</strong>
        <p>
          损失限制在特定金额的指令（例如“止损限价”指令）有可能并不见效或无法执行。如果订单是停损限价单，无法保证订单能以限价执行或会执行。此外，一些使用头寸合并的策略，例如差价或同价对敲或许与单做“长仓”或“短仓”存在有相同的风险。
        </p>
        <h3>其他贵金属交易的额外风险</h3>
        <strong>3.贵金属交易的条件与条款</strong>
        <p>客户必须清楚理解买卖贵金属的条件与条款及其义务。</p>
        <strong>4.电子交易</strong>
        <p>
          通过电子交易系统进行的交易，在传送和接收客户指示或其他资料时可能出现延误，在执行客户指令时亦可能出现延误或以有别于客户所发出指示之价格执行其指示，通讯设施亦可能出现故障或传输中断。客户将面临该系统带来的相关风险，包括硬体和软体的故障。系统故障可能造成客户的订单难以按照客户的指示执行，甚至根本不能执行。因此，客户承认并接受，由于无法预计的通讯阻塞或其他原因，电子传送不一定是一种可靠之通讯方法，客户须承担因通讯误解、错误及其一切相关的风险。
        </p>
        <strong>5.交易设施</strong>
        <p>
          大部分电子交易的设施是由以电脑为基础的系统来支持处理交易指令传递、执行、配对、登记和交易结算的。该类系统易受到临时故障的影响。客户收回某些损失的能力可能受制于系统提供者、市场、清算所等的有限度责任。这些有限度责任可能是各有不同的。
        </p>
        <strong>6.交易所场外交易</strong>
        <p>
          在某些司法管辖区，且仅在限定的情形下，公司可被允许进行场外交易，为客户进行交易的公司可能是客户的交易对手。香港金盛贵金属有限公司在很多贵金属交易中是客户的直接交易对手。香港金盛贵金属有限公司有权拒绝接受或保证任何订单。所以平仓、评估价值、确定公平价格或评估风险可能很困难或不可能。鉴于这些原因，这类交易可能涉及更大的风险。场外交易可能受到较少的监管或受管于不同的监管体系。客户在开始交易之前，应该清楚了解适用的规定和相关风险。
        </p>
        <strong>7.暂停或限制交易与定价的关系</strong>
        <p>
          市场状况以及/或某些市场的运作条例（例如由于停市造成的任何贵金属暂停交易），有可能增加客户损失的风险，因为完成交易或平仓等交易指令有机会已经变得很困难或不可能。此外，相关资产与贵金属的正常价格关系可能不存在，缺乏相关资产的参考价格，因此很难评估或确定
          “公平”价格。</p>
        <strong>8.在其他司法管辖区的交易</strong>
        <p>
          在其他司法管辖区市场（包括正式连接到本地市场的市场）进行的交易可能使客户面临其他风险。在那些市场的规定下，投资者受到的保障可能不同或甚至会减低对投资者的保障。在开始交易前客户应该询问任何与客户交易有关的规定，并了解本身所在地及其他司法管辖区可得到的补偿。
        </p>
        <strong>9.存放的现金与财物</strong>
        <p>
          客户必须确认，将金钱或其他财产交由金盛贵金属、其代表或其授权人保管均附有风险。客户须熟悉各种有关客户为进行当地或外地交易存放的金钱与财产有哪些保障，特别是在公司面临财困或破产的时候。客户可收回现金与财产的程度，是受制于特定法例或当地的规则或可能严重延迟。此为客户须准备承受之风险。
        </p>
        <strong>10.客户非本人存款安排</strong>
        <p>
          为了保障客户资金安全，防止不良客户进行洗黑钱等违法活动，金盛贵金属作出以下规定：<br>
          金盛贵金属不接受非本人（第三方）银行账户入金。
          金盛贵金属保留调查核实和拒绝客户以非本人（第三方）户口入款的权利。客户若使用非本人姓名账户入金而未能提交第三方户口证明资料，金盛贵金属有权即时冻结客户账户进行调查，禁止其账户进行一切交易，并完全有权对客户账户进行以下处理：
          <br>
          1. 若客户账户从未进行任何交易，金盛贵金属将所有第三方存款扣除10%作为合理营运成本后，将其余额退回入款银行账户中；
          <br>
          2. 若客户账户已进行任何交易，金盛贵金属将由第三方存款起的所有交易及优惠 (包括点差回赠，赠金等优惠)取消。并将所有第三方存款扣除10%作为合理营运成本后，将其余额退回入款银行账户中；
          <br>
          3. 对于以上情况，金盛贵金属可依据酌情权决定向任何相关监管机构或执法机构报告有关事件。同时,本公司有权即时冻结相应客户账户并禁止其进行一切交易,并依据酌情权决定向任何相关监管机构或执法机构报告相关事件。
        </p>

        <strong>11.交易佣金与其他收费</strong>
        <p>
          客户在开始交易之前，应该了解清楚客户将支付的所有佣金、费用及其它收费。这些收费将会影响客户可能有的盈利或增加客户的损失。客户明白贵金属账户不是作存款用途而且无利息收益。</p>
        <strong>12.账户使用 </strong>
        <p> 若交易账户连续三个月未有交易，我司会自动关闭账户。</p>
        <p class="fxpl">*代理经纪人披露*<br>
          香港金盛贵金属有限公司(以下简称「本公司」)和代理经纪人完全独立，本公司没有监管其代理经纪人的活动，并不对代理经纪人作出的声明负责。本公司和代理经纪人直接的协议并不建立合伙或合资机构关系，因此代理经纪人不是本公司的代表或职员，并无权代表本公司进行交涉或采取任何其他行为：
        </p>
        <p>
          1.客户理解并同意如果客户在本公司的账户是由代理经纪人介绍而来，该代理经纪人可以查阅客户的个人资料和其他有关客户在本公司账户交易活动的数据。代理经纪人有权进入客户的本公司账户，但不得以客户的本公司账户进行任何交易，除非客户通过书面协议授权该代理经纪人代表客户交易。
        </p>
        <p>
          2.客户理解并确认本公司可能对代理经纪人给予报酬，此类报酬可能按照每笔交易或其他方式给予。此报酬有可能需要扩大给客户的点差。本公司更保留向客户收取佣金及相关手续费的权利。此外，客户有权获准确地告知该点差收费、佣金或手续费的详细内容。
        </p>
        <p>3.客户理解经由代理经纪人或第三方处理的客户资金，只要不在本公司的管理、保管或控制范围，本公司均不需承担任何责任。</p>
        <p>4.客户理解代理经纪人或其他出售/提供交易系统，课程、程序、研究或建议的第三者是与本公司没有关联，该服务是不受政府机构监管。本公司绝不对客户使用该信息或建议带来的损失负责。</p>
        <p>5.客户在此确认，同意和理解贵金属交易所带来的一切风险，同时明白通过任何第三者的交易系统、课程、程序、或由代理经纪人提供的研究或建议进行的交易并不一定带来盈利，避免风险或限制风险。</p>
        <p>6.客户确认本公司及与其代理经纪人未就客户未来的盈亏作出任何许诺。客户明白贵金属交易带有相当高的风险，客户必须细阅上述的&lt;&lt;风险披露声明&gt;&gt;。</p>
        <p>7.对于客户已经或将会从代理经纪人或其他任何第三方获得的信息或建议，本公司不能控制，也不会支持或担保其信息及建议的准确性或完备性。</p>
        <p>
          8.本公司不支持或担保代理经纪人所提供之服务，由于代理经纪人不是本公司的职员，因此客户有责任在接受该代理经纪人的服务前应严格评估该代理经纪人。
        </p>
        <p>
          9.客户声明及保证其并非美国公民╱居民（作为缴税或其他目的），亦并非以其他方式就任何目的而言与美国有所关联，亦并非以代表任何美国公民╱居民╱实体的代理人身份行事。倘若上述之声明及保证有任何改变，客户承诺在该改变时立即以书面通知本公司。
        </p>
        <p class="fxpl">*客户告鉴*<br>
          本协议具有法律约束力，请仔细审阅。<br>
          本法律合约乃由香港金盛贵金属有限公司(以下简称「本公司」)；一家在香港特别行政区法律下成立的有限公司，其后继人或转让人，与本文档的合同方（以下简称「客户」）共同订立。<br>
          有关在本公司开设账户通过贵金属场外OTC市场从事投机及或购买、及或卖出现货贵金属（以下简称「OTCGOLD」），客户确认已了解下述有关杠杆式OTCGOLD交易的因素，以及提供给客户的风险披露声明。
        </p>
        <p>1.OTCGOLD交易仅适合专业机构或投资经验丰富的人士，其财政状况也许可以承受远过保证金或存款金价值的损失。</p>
        <p>
          2.OTCGOLD的业务并不需公开喊价。虽然许多场所交易都以计算机为基础的系统提供报价和实际价格，但这两价格可能会因为市场缺乏流动性而有所偏差。许多电子交易设施是由以计算机为基础的系统来支持进行交易下单、执行、配对的，它们易受到临时系统故障的影响。客户收回某些损失的能力可能受限于系统提供者、银行及／或其他金融机构设定的责任限度，此限度可能各有不同。
        </p>
        <p>
          3.在OTCGOLD市场上，公司不只于交易所场外进行交易。为客户进行交易的公司香港金盛贵金属有限公司在很多贵金属交易中可能是客户交易的对手。可能出现的情况，包括平仓、评估价值、确定公平价值或评估风险披露会很困难或不可能。鉴于这些原因，这类交易可能涉及更大的风险。场外交易可能受到较少的监管或受管于不同的监管体系。在开始交易之前，客户应该了解适用的规定和相关风险。
        </p>
        <p>4.如果客户在任何电子市场从事交易，客户将面临与该电子交易系统相关的 风险，包括硬件或软件的故障。系统故障可能造成客户的订单难以按照其指示执行或根本不能执行。</p>
        <!-- <h3>免责条款：</h3>
      <p>(i)互联网故障</p>
      <p>互联网的运作不在本公司控制范围之内，因此不能确保通过互联网的接收和发放的信号，客户电子设备的结构或联接的可靠性，本公司绝不对互联网上交易中出现的通讯故障、错误或延迟负责。</p>
      <p>(ii)市场风险和网上交易</p>
      <p>贵金属交易涉及相当大的风险，其并非对每位投资者都适合。请参照风险披露声明和本协议，了解有关风险的详细资料。虽然网上交易为客户带来很多方便或更有效率，但它并不降低贵金属交易本身的风险。因此客户在交易前，须准备承担此风险。</p>
      <p>(iii)密码保护</p>
      <p>客户必须将密码保密，确保没有第三方取用其交易设施。客户同意对所有经电邮或电子交易平台传送来的指示和对所有经由电邮、电子交易平台、电话或书面向本公司发出的指示确实负责，即使是由第三方发出，这些指示已和客户密码或客户签名和账户号码认证，根据本公司的判断相信这是客户表面授权。本公司并没有责任对这个表面权限作进一步查询，也没有责任因为依据这些表面权限所采取的不采取的行动所造成之后果负责。客户须对密码的保密性、安全性及其使用独自承担责任。</p>
      <p>(iv)报价错误</p>
      <p>倘若报价或成交价出现错误时，本公司对于账户结余相应错误并不负责。有关错误可能包括但不限于：交易员的错误报价、非国际市场价之报价、或是任何报价错误（例如由于硬件、软件或者通讯线路或系统故障导致报价错误或者第三者提供了错误的外部数据）。本公司不需为错误所导致的账户余额负责，客户下单时需预留足够的时间执行订单和系统计算所需保证金的时间。若订单的执行价格或订单设定和市场价格过于接近，这可能会触发其他订单（所有订单类型）或发出保证金提示。本公司不会对由于系统没有足够时间执行订单或进行运算所产生的保证金提示、账户结余或账户头寸负责。情况不限于上文，一旦发生报价或执行错误，本公司保留对有关账户进行必要更正或调整的权利。对于报价或执行错误而产生的任何争议，本公司将依据绝对酌情权进行解决。若因此带来任何损失、损害或责任，客户同意予以赔偿使本公司不会受到任何损失或损害。</p>
      <p>(v)套戥</p>
      <p>互联网、联机延误、报价上的误差或报价系统的漏洞有时会造成在本公司交易平台上的报价无法准确地反映实时市场价格。「套戥」及「剥头皮」，或因网络连接的延误而利用差价获利的行为，并不能存在于客户直接向庄家进行买卖的场外交易市场中。本公司不容许客户在本公司的交易平台上进行此等套戥活动。任何客户利用潜在套戥及「剥头皮」机会所从事的价格交易可能会被取消。本公司保留权利对涉及上述交易的账户进行必要的修正和调整。本公司可依据绝对酌情权，要求交易员进行干预或核准所有下单以及或终止有关客户的账户，而不需事先通知客户。对「套戥」及「剥头皮」或操控价格而产生的纠纷，本公司将依据绝对酌情权进行解决。本公司保留冻结客户提款的权利直至能够完全解决上述的问题为止。于此陈述的任何行动或决议将不会损害或放弃令本公司对客户和其雇员拥有之任何权力或赔偿。</p>
      <p>(vi)操控价格、执行及平台</p>
      <p>本公司绝对严禁以任何形式对其价格、执行及平台进行操控。若本公司怀疑任何账户从事操控（包括但不限于客户未经本公司批准进行的第三者交易），本公司保留对账户进行调查及审核等的相关权利，并从涉嫌账户中扣除由相关活动所赚取的盈利款项。本公司保留对相关账户进行必要更正或调整的权利。对于涉嫌从事操控的账户，本公司依据绝对酌情权，要求交易员进行干预、对下单进行核准以及或终止有关客户的账户。对于由套戥及或操控所产生的任何纠纷，本公司将依据绝对酌情权进行解决。本公司可依据酌情权决定向任何相关监管机构或执法机构报告有关事件，而不会就事件报告通知相关客户。于此处所陈述的任何行动或决议并不免除或损害本公司对客户和其雇员拥有之任何权利或赔偿。</p>-->
        <p>
          5.客户确认购买或卖出贵金属包括进行交割，每次现货交易均自动进账到客户的账户。所有需要作实货交收的买卖合约，客户必须在发出买卖指示时，同时以书面通知本公司及得到本公司确定接受方为有效。交收时间及地点将由市场惯例或本公司酌情决定。本公司有绝对酌情决定权拒绝执行客户任何买卖指示，而绝不须对拒绝执行买卖指示向客户作出具体解释或原因。
        </p>
        <p>
          6.本公司不能保证客户的交易对手的信誉。本公司只有尽力与有良好声誉及可靠的机构和清算所进行交易。此外，本公司可能因为交易流动性的问题，造成贵金属交易停止，使客户不能及时为亏损的头寸进行平仓，这可能为客户带来相当的损失。本公司不会就这些损失承担任何责任。
        </p>
        <p>7.本公司的保证金政策可能要求客户提供追加资金以便维持其保证金账户，客户有义务满足这类保证金要求。否则将可能被自动平仓及造成相应的损失。本公司还保留拒绝接受订单的权利或提供市场对冲。</p>
        <p>8.如果任何非本公司雇员（下称“第三方”）向客户提供任何关于贵金属的信息或建议，本公司不能控制或担保其关于贵金属的准确性和完整性，本公司将决不对客户因使用该信息或建议带来的损失承担任何负责。</p>
        <p>
          9.如果客户将交易授权或对其账户的管理交予第三方，不论是自主权或非自主权的方式，本公司将绝不对客户作出的选择负责。本公司不对有关交易的第三方作出任何声明或保证；本公司不对因为交易第三方的行为对客户产生的损失负责。因此，若客户授权第三方管理其账户，客户必须自己承担一切相关风险。如果客户未获本公司同意将交易授权或对其帐户的管理交予第三方，本公司保留对有关账户所有或部份相关的交易进行取消的权利，而不需事先通知客户。
        </p>
        <p>
          10.客户应完全遵守当地有关法例，包括为遵守该等地区或司法管辖权区内须遵守之任何其他手续而取得政府或相关监管机构之同意，以及因使用本公司平台进行的交易而需支付当地任何相关税项、关税及其他金额。客户在本公司平台进行的交易，将被视为该客户向本公司属声明及保证已遵守当地法律及规定。倘客户对相关情况有疑问，客户应在开户及开始交易前应该咨询法律及其它独立的专业意见。
        <p>11.所有客户必须意识到任何回报是非保证的。此外，本公司不对任何本公司、其雇员及/或关联人作出的指称或保证负责。</p>
        </p>
        <h3 style="font-weight: bold;font-size: 18px">客户协议</h3>
        <strong>1.字词释义及标题</strong>
        <p>
          “本公司”或“金盛贵金属”一词包括香港金盛贵金属有限公司，其部份继承人和转让人。“客户”一词指订立本协议的一方。如客户为个人，则包括客户本人，其遗嘱执行人及遗产管理人；如客户为有限公司，则包括该公司及继承人。如客户为合伙公司，则包括客户账户保持有效时的合伙人、其遗嘱执行人及遗产管理人。
          “协议”一词指客户与本公司就有关账户（等）之开设、维持及运作而订立且不时修定之协议或给予的授权，其中包括但不限于本客户协议、风险披露声明、客户告鉴、开户申请表（等）而给予本公司之任何权力。本协议的段落标题为查考方便而加入的，此并不限制或影响段落条文的应用与意义。
        </p>
        <strong>2.资格声明与保证</strong>
        <p>(A)头脑健全，到达法定年龄，具有法律能力；<br>
          (B)只有账户持有人/客户本人享有其账户之利益；<br>
          (C)不论此后任何相反的裁决，除了（A）所述，客户有足够投资经验、承受风险及财政上的能力以进行OTCGOLD交易；<br>
          (D)客户目前不受雇于任何交易所、任何交易所持有绝大部分资本的公司、任何交易所的成员及或任何在交易所注册的公司、任何银行、信托机构或保险公司，若客户受雇于上述公司，客户必须立即以书面形式通知本公司；<br>
          (E)客户提供的信息（至本日期止）皆为真实、准确和完整。若任何讯息变化，客户有责任迅速通知本公司。<br>
          (F)完全遵守当地有关法例，包括为遵守该等地区或司法管辖区内须遵守之任何其他手续以取得政府或其他方面之同意，以及因为
          使用本平台进行交易而需要支付当地任何相关税项、关税及其他金额。客户在本平台进行交易，将被视为该客户向本公司声明及保证已遵守当地法律及规定。倘若客户对情况有疑问，客户必须寻找专业之法律意见；<br>
          (G)不会进行任何以套戥或「剥头皮」为目标的活动。
          不会于未获本公司批准将交易授权或对其帐户的管理交予第三者。</p>
        <strong>3.高风险投资及风险确认</strong>
        <p>
          除这项协议所载标准披露外，客户应注意以保证金为基础的贵金属交易是金融市场上最高风险的投资工具之一，且仅适合于有丰富经验的专业投资者和机构。在本公司开立的账户允许客户以很高的杠杆比例（可高达客户账户资产的100倍，杠杆比例可由本公司不时修改或者按照其他适用的规例）进行贵金属交易。客户在开户或进行贵金属交易之前应仔细地考虑其可承受之风险，并明白在贵金属交易进行投机的资金是属于风险资本金。客户保证及声明即使在贵金属交易中出现严重亏损也不会对其现在/未来的生活方式及财政状况带来任何影响。若客户过往未曾投资于高风险的投资工具，客户需要在正式买卖之前了解和学习贵金属交易相关知识，并咨询有关专业意见。客户需要认识到贵金属交易涉及潜在的利润与损失，若市况不利，损失可能超过初始保证金之金额。在交易贵金属时客户必须确认其投资于贵金属交易的资金是纯风险资本金，这些资金的损失并不会对其现在/未来的生活方式及财政状况带来任何影响。
          客户确认投资于杠杆式交易是投机性，并涉及相当高之风险，只适合于能够承担超过其保证金存款损失风险的人士。客户理解由于OTCGOLD交易通常要求的保证金较低，因此杠杆比例相对较大，以致OTCGOLD的价格变动可能带来相当大的损失，该损失可能超过客户的投资和保证金存款。客户须在开户或进行交易之前，应该清楚了解有关交易特性和风险程度，保证其愿意并能够在财务上或其他方面承担OTCGOLD交易所带来的所有风险，客户同意不会就因遵循本公司或其雇员或代表作出的交易推荐，或建议而造成的交易损失追究本公司的责任。客户认识到OTCGOLD交易是没有任何保本或盈利的保证。客户承认其未曾从本公司，或其任何雇员、代表、代理经纪人，或其他客户与之打交道以进行本公司交易的实体从而获得这类保证，并且未根据任何上述保证签订本协议。
        </p>
        <strong>4.汇率变动风险</strong>
        <p>本公司之交易帐户必须以美元或本公司不时同意之其他货币为单位，倘若客户以美元之外之其他货币存取款：<br>
          i 客户必须独自承担因汇率价格变动而导致之任何收益或损失；<br>
          ii 客户同意本公司按其全权决定之形式及时间对货币作出任何兑换，以实行其根据本协议而采取之任何行动或步骤。</p>
        <strong>5.结算及保证金</strong>
        <p>
          客户须明白及同意本公司拥有唯一指定权，根据市场状况，本公司可能在任何时候改变保证金要求。该保证金金额相比同业机构的要求可能较高或可能较低。客户同意当本公司作出追补资金之要求时，客户须立即并迅速以本公司所要求的存款方式满足所有保证金催促通知的要求，而任何存款过程涉及的费用，包括银行手续费、汇率差价及所有有关费用均由客户承担。客户有可能不可以实时使用刚存入的保证金作为新头寸的按金，更可能不可以作为追加保证金，客户同意承担一切由于未能及时满足追加保证金要求而面临强制平仓之损失，其损失可能超过客户的初始保证金，即账户内的所有资金。本公司可能在任何时候根据本协议的规定强制客户的账户进行平仓，即使本公司不行使该项权利，并不代表其放弃该权利。任何本公司过去的保证金要求均不妨碍本公司不需通知而提高上述保证金要求。客户有权随时通知本公司提取指定的可用现金结余，客户同意任何汇款及转款过程涉及的费用，包括银行手续费、汇率差价及所有有关费用均由客户承担。客户完全理解本公司及相关银行需要时间去处理有关客户之提款，客户很可能不可以实时收到所提取的金额。客户同意不追究本公司由于未能及时满足自身提款要求所引起的所有责任。当客户的提款要求一经确认，本公司将实时从客户账户结余扣除该款额。客户必须确保其所指定的往来银行账户属于客户本人，本公司不会接受任何第三者（包括但不限于第三方）存取款。<br>
          客户确认及同意客户进行未获授权的第三者存款时，本公司完全拥有权利对客户账户进行以下处理:<br>
          (A)若客户帐户从未进行任何交易，本公司将所有第三方存款扣除百分之十作为本公司营运成本后，将其余额退回存款银行帐户；<br>
          (B)若客户帐户已进行任何交易，本公司将由进行第三者存款起的所有交易及优惠（包括但不限返佣、赠金）取消。并将所有第三者存款扣除百分之十作为本公司营运成本后，将其余额退回存款银行帐户；<br>
          (C)实时冻结客户账户进行调查，禁止其帐户进行一切交易。并依据酌情权决定向任何相关监管机构或执法机构报告有关事件。</p>
        <strong>6.抵押</strong>
        <p>
          客户的所有资金、货币及其它财产，如其被本公司在任何时候为客户持有，或在任何时候由本公司为任何目的（包括妥善保管）掌管或控制，此类财物将被本公司作为担保物，并可因客户对本公司的义务受制于普通留置权及对冲权，不论客户在本公司开立账户数目的多少。本公司可能在不通知客户的情况下行使其绝对酌情权，在任何时候将客户的所有资金、货币或其他财产投入或转向客户的任何账户。客户亦授权本公司以单独或者与其他客户的财产一起的形式，将客户作为保证金或担保物的任何财产以进行抵押、再抵押、投资或出借于本公司自身或其他方。此授权适用于所有本公司为客户开持的账户，并在客户全额付清所有债务之前、或本公司发出撤销通知之前有效。
        </p>
        <strong>7.交易</strong>
        <p>
          本公司可以与客户部分或全部的买卖指令进行对盘及／或下达市场。本公司获授权按照客户的口头、书面或计算机指令向对手方如银行、金融机构或资深参与者为客户账户进行OTCGOLD买卖。除非客户以书面形式作出反对，否则本公司获授权向本公司认为适合之对手方如银行、金融机构或资深参与者执行所有订单。本公司有权依据所有从客户方收集到的口头或书面上的通信或指示，包括客户的雇员、合伙人、法定负责人（授权人），只要本公司没有收到客户通知授权人并没有获得授权。客户同意让授权人代表客户向本公司提供所需的数据、信息、指示、和权来进行本公司提供的服务。<br>
          客户授权本公司依据和执行从授权人方所得来的任何指示、授权或信息。所得来的方式包括通过电子方式传送或获得客户批准的传真文件。因此客户同意（i）本公司获授权执行指示，并且不需询问有关指示的有效性，该指示会被当作是授权人发出的书面指令；（ii）在任何情况下，本公司不需核实指示的有效性或任何个别情况的签名；（iii）在本公司秉承行事和没有疏忽的情况下，客户将承担所有由任何代表人、雇员、或授权人发出未经批准指示的风险，客户将为任何损失、费用、酬金、损毁、经费、索赔、诉讼或要求（等）负责。客户并保证不向本公司追究责任或要求赔偿，以及本公司不会因上述情况而导致损失，亦包括任何有关或产生自本公司的实际行动、延迟实际行动或拒绝采取行动、由客户提供给本公司的任何指示或数据，包括由客户的雇员、授权人或代表发出的不正当、未经授权、虚假或欺诈指示，即使该指示是没有获得客户授权。
          本公司有权限制客户每次下单的总数。本公司有权限制客户获得或持有的头寸金额及／或总数。本公司将按照客户计算机或录音电话的指示执行其选择接受的订单。本公司有权拒绝接受任何订单。</p>
        <strong>8.电子传输交易确认及账单报告</strong>
        <p>
          客户同意其帐户信息与交易确认可经由本公司平台提供，客户可通过本公司的平台或网上个人帐户查阅其帐户资料。本公司将公布客户的所有帐户交易活动数据，客户将可以获得每日、每月的帐户交易报表，以及每项已执行的交易之报表。客户的网上账户公布其账户事务数据将被视作递交了交易确认和帐户结单，任何时候，帐户数据将包括带有交易确认编号、买卖价格、占用保证金、可用保证金的数额、盈亏报告，以及所有头寸和未完成下单指令等。订单的确认报告（如日结单、月结单等）和客户的帐户报表将被视作正确、终结性，并对客户具有约束力，除非客户在收到本公司网上交易平台或其他方式送达的报告两日之内立即作出反对，并以书面形式确认。保证金催促将是终结性并有约束力的，除非立即以书面形式作出反对。作为邮寄交易确认的代替，本公司将向客户提供互联网上登入以便随时查阅其账户。若客户反对应以书面形式寄往本公司网页上最新提供的办事处地址，请要求回邮收据。如无反对，则本公司或其代理经纪人在客户收到上述报告之前采取的所有行动将被视作已被批准。客户未收到交易确认将并不解除其作出上述反对的义务。当订单或交易一经执行，确认一经发出，只有客户有责任查阅并记录帐户内的所有订单和持仓。
        </p>
        <strong>9.收费</strong>
        <p>
          客户将支付因本公司所提供的服务产生的手续费、代理经纪人佣金和其他特别服务之所有费用（包括但不限于溢价和折价，报表费，闲置帐户费，指令取消费，转账费和其他费用）及收费（包括但不限于由银行间机构、银行、合约市场或其他监管或自律组织收取的费用）。本公司可能不经通知调整收取佣金、费用及/或收费。客户同意向本公司支付其欠交款项的利息。所有这些费用将在发生时，或在本公司根据其绝对酌情权决定下由客户支付。客户同意本公司从其账户中冻结上述费用。在客户指示本公司将其账户的未平仓头寸、资金、及/或财产转向其他机构时，客户同意支付由本公司确定的转账费。本公司确认所有向客户报出的价格但不包括溢价与折价。
        </p>
        <strong>10.欠款</strong>
        <p>如发生下列情形：<br>
          i客户身故、神经失常或司法宣定无能力；<br> ii　客户申请破产，或选派托管人，或任何人针对客户向法庭申请其破产、清盘或其他相类似的法律程序； iii
          客户的任何资产遭委任接管人或类似职位人员接管，或遭受任何扣押或判决之执行；
          iv不论当时的市场报价如何，客户的账户保证金金额不足； v
          客户未能向本公司提供任何根据本协议要求的相关资料（如身份证明文件）；或任何其他本公司应当采取保护措施的情况或变化，本公司拥有绝对酌情权决定应否采取以下某种或多种行动；<br>
          （1）本公司代为客户保存或控制的资金或财产来抵偿客户对本公司负有的债务；（2）买卖任何为客户于其账户持有的贵金属头寸；及（3）取消任何或所有未完成订单，或其他任何以客户名义作出的承诺。采取任何上述行动可能并不以下列为条件：即要求提供保证金或追加保证金，或事先将买卖决定通知客户、客户的个人代表、继承人、授权人或转让人等、且不论涉及的所有权利益是否为客户独有。根据本公司的绝对酌情权，在此所述的买卖行为可以通过任何银行间或其他经常进行业务的交易市场进行，本公司可以购买全部或部分而不受赎回权的限制。当本公司向客户提出要求，客户将在任何时候对其账户的债务负责。若其账户被本公司或客户自己全部或部分平仓之时、在任何时候均对其剩余欠款负责。如果根据本授权进行的平仓后所兑现的资金不足以支付客户向本公司所欠的债务，客户需立即支付欠款、所有未偿还债务、以及相应利息，以及所有托收费用，包括律师费、证人费等相关费用。本公司并保留追究权利。此后，本公司可完全自行决定合并客户名下的多个户口，把盈余抵销账户之间的借方差额。
        </p>
        <strong>11.个人资料私隐政策</strong>
        <p>
          本公司的个人资料私隐政策是根据《个人资料（私隐）条例》保护客户权益。在本公司使用客户数据用以提供其最佳服务时，亦会高度关注于其客户数据使用之安排。本公司会根据香港特别行政区法例《个人资料（私隐）条例》之规定，力求完全符合个人资料保障要求。为此，本公司会确保其雇员遵守法例规定的保安和保密严谨标准。<br>
          (A)本公司收集的各项个人资料，只供本公司进行业务运作及其他有关活动之用；<br>
          (B)本公司致力确保网站是安全及符合业界标准，并且使用其他数据保障工具，例如：防火墙、认证系统（密码和个人身份证号码等）和操控机制来控制未获授权的系统进入和存取数据；<br>
          (C)本公司会将客户个人资料保密储存，保护客户的个人资料以防止被盗用，本公司雇员亦会尊重客户的私隐，绝不会向未获授权人士透露任何数据；<br>
          (D)客户可不时查阅及更改由金盛贵金属所保存有关其个人资料；<br>
          (E)客户同意本公司会根据任何法例或监管机构之规定，向监管当局及其他政府机构披露客户所有数据（及其他数据）；<br>
          (F)客户同意本公司按照网络支付系统政策之安排，当客户透过支付网关进行存取款时，向有关机构披露客户个人资料作为核实身份的证明；<br>
          (G)本公司可能会在客户的计算机设定及存取本公司Cookies，以协助本公司分析并了解有关之市场推广策略的效果。本公司及其雇员可能会于本公司的产品和服务使用Cookies
          来追踪客户在本公司网站的浏览，收集得来和共享的资料是不具姓名及无法被个别辨识的；<br>
          (H)客户同意本公司向客服提供服务时，本公司可能授权一些不隶属本公司的公司使用客户个人资料，这些包括以合约形式代表本公司提供服务的公司，例如作成、邮寄月结单的公司，维护及开发数据处理的软件公司等。这些授权于本公司的公司必须把客户的个人资料保密。<br>
          本公司将尽一切所能确保其收集所得的客户个人资料被妥善地保存在储存系统，并只有获授权的雇员或代表本公司提供服务的公司可查阅有关资料，但鉴于互联网之公开及全球性质，本公司可能无法保护及保密客户个人资料不受第三者的蓄意干扰。凡经由本公司网页浏览他人运作的网页，客户的个人资料均不属本公司的个人资料私隐条款保障范围内。
          在直接促销中使用数据本公司/集团拟把客户数据用于直接促销，而本公司/集团为该用途须获得客户同意（包括表示不反对）。就此，请注意：
          (A)本公司/集团可能把持有的客户姓名、联络方式、产品及服务组合数据、交易模式及行为、财务背景及人口统计资料用于直接促销；<br>
          (B)可用作促销下列类别的服务、产品及促销标的；<br>
          a.金融、理财、投资及相关服务及产品；<br>
          b.奖赏、优惠计划及相关服务及产品；<br>
          c.本公司/集团的任何成员与品牌合作伙伴提供之服务及产品（该等品牌合作伙伴名称会于有关服务及产品的申请表格上列明，视情况而定）；及为慈善及/或非牟利用途的捐款及捐赠；<br>
          (C)上述服务、产品及促销标的可能由本公司/集团及/或下列各方提供或征求：
          a.本集团的任何成员、合作伙伴及联营公司;
          b.第三方金融机构、投资服务供货商、奖赏及优惠计划供货商，及合作品牌供货商；及慈善或非牟利机构；
          (D)除促销以上述服务、产品及促销标的以外，本公司/集团亦拟以上
          34(i)段所述的数据提供予以上34(iii)段所述的全部或任何人士，以供该等人士在促销该等服务、产品及促销标的中使用，而本公司/集团为此用途须获得客户书面同意（包括表示不反对）；如客户不希望本公司/集团如上述使用其数据或提供数据予其他人士作直销促销用途，客户可通知本公司/集团行使其选择权拒绝促销。
        </p>
        <strong>12.信息及通讯联络</strong>
        <p>若客户的个人资料有任何更改，客户有责任立即通知本公司有关之更改。
          报告、报表、通知及其它通讯可能送达至客户于开户申请时所提供的电邮地址及住址或客户不时以书面方式（香港客户）和网上登入方式（国内/海外客户）向本公司更新的电邮地址及住址。所有如此送出的通讯，不论是邮寄、电邮或其他方式，一旦投入有关邮政，或经发送机构接收，即被认定已由本公司传出，且被认定该通讯已送达客户本人，不论客户是否实际收到。
        </p>
        <strong>13.政府、对手机构及银行间系统规条</strong>
        <p>
          所有本协议下的交易均受辖于执行交易的对手机构或其他银行间市场（及其清算组织，如适用）的宪章、细则、条例、规定、习惯、用法、裁决和解释，并执行所有适合的香港法律。如果此后通过的任何法令，或任何政府机构通过的任何条款，或对本协议产生影响／冲突的任何条款，将视作被有关法令、条规变更或替代，而其他条款及变更后的条款将继续完全生效。客户承认本协议下的所有交易受辖于前述监管要求。所有客户不拥有任何有关上述要求独立的合约性权利。
        </p>
        <strong>14.清算日与延展</strong>
        <p>所有贵金属头寸会在交易日以美元显示在客户的帐户，并在48小时内清算，并以美元作为交收货币。持仓头寸会在额外48
          小时后自动过仓，除非（i）客户给予令人满意的指示交割，这要按照本公司的惯例、通常收费和重新交付费用；（ii）本公司接受了客户的下单并同意可全权酌情决定对冲贵金属头寸。客户应在贵金属清算日的前一个工作天正午之前指示是否交割或对冲。如无客户的及时指示，本公司被授权全权酌情决定是否延展所有或任何客户的本公司账户的货币头寸，风险由客户承担。客户的账户将在贵金属头寸延展之时收取利息。
        </p>
        <strong>15.录音</strong>
        <p>客户同意本公司有权采用录音程序，以作为所录取指示或通讯之确实证据。客户进一步同意在涉及任何客户或本公司的纠纷或诉讼中，任何一方可以使用此类录音或备份作证据。客户理解并同意本公司定期根据其确立的营业程序清除这类录音。
        </p>
        <strong>16.香港金盛贵金属有限公司的责任</strong>
        <p>本公司将不负责因传输或通讯设施故障、电力短路或任何其他本公司不能控制或预计的原因带来的指令传输的延迟。本公司将仅对直接因为本公司的蓄意过错或欺诈造成的行为负责。本公司将不对其他方面过错而引起的损失承担任何责任。</p>
        <strong>17.免责条款</strong>
        <p>(A)互联网故障<br>
          互联网的运作不在本公司控制范围之内，因此不能确保通过互联网的接收和发放的信号，客户电子设备的结构或联接的可靠性，本公司绝不对互联网上交易中出现的通讯故障、错误或延迟负责。<br>
          (B)市场风险和网上交易<br>
          贵金属交易涉及相当大的风险，其并非对每位投资者都适合。请参照风险披露声明和本协议，了解有关风险的详细资料。虽然网上交易为客户带来很多方便或更有效率，但它并不降低贵金属交易本身的风险。因此客户在交易前，须准备承担此风险。
          (C)密码保护<br>
          客户必须将密码保密，确保没有第三方取用其交易设施。客户同意对所有经电邮或电子交易平台传送来的指示和对所有经由电邮、电子交易平台、电话或书面向本公司发出的指示确实负责，即使是由第三方发出，这些指示已和客户密码或客户签名和帐户号码认证，根据本公司的判断相信这是客户表面授权。本公司并没有责任对这个表面权限作进一步查询，也没有责任因为依据这些表面权限所采取的/不采取的行动所造成之后果负责。客户须对密码的保密性、安全性及其使用独自承担责任。<br>
          (D)报价错误<br>
          倘若报价或成交价出现错误时，本公司对于账户结余相应错误并不负责。有关错误可能包括但不限于：交易员的错误报价、非国际市场价之报价、或是任何报价错误（例如由于硬件、软件或者通讯线路或系统故障导致报价错误或者第三者提供了错误的外部数据）。本公司不需为错误所导致的账户余额负责，客户下单时需预留足够的时间执行订单和系统计算所需保证金的时间。若订单的执行价格或订单设定和市场价格过于接近，这可能会触发其他订单（所有订单类型）或发出保证金提示。本公司不会对由于系统没有足够时间执行订单或进行运算所产生的保证金提示、账户结余或账户头寸负责。情况不限于上文，一旦发生报价或执行错误，本公司保留对有关账户进行必要更正或调整的权利。对于报价或执行错误而产生的任何争议，本公司将依据绝对酌情权进行解决。若因此带来任何损失、损害或责任，客户同意予以赔偿使本公司不会受到任何损失或损害。<br>
          (E)套戥<br>
          互联网、联机延误、报价上的误差或报价系统的漏洞有时会造成在本公司交易平台上的报价无法准确地反映实时市场价格。「套戥」及「剥头皮」，或因网络连接的延误而利用差价获利的行为，并不能存在于客户直接向庄家进行买卖的场外交易市场中。本公司不容许客户在本公司的交易平台上进行此等套戥活动。任何客户利用潜在套戥及「剥头皮」机会所从事的价格交易可能会被取消。本公司保留权利对涉及上述交易的帐户进行必要的修正和调整。本公司可依据绝对酌情权，要求交易员进行干预或核准所有下单以及或终止有关客户的账户，而不需事先通知客户。对「套戥」及「剥头皮」或操控价格而产生的纠纷，本公司将依据绝对酌情权进行解决。本公司保留冻结客户提款的权利直至能够完全解决上述的问题为止。于此陈述的任何行动或决议将不会损害或放弃令本公司对客户和其雇员拥有之任何权力或赔偿。<br>
          (F)操控价格、执行及平台<br>

          本公司绝对严禁以任何形式对其价格、执行及平台进行操控。若本公司怀疑任何账户从事操控（包括但不限于客户未经本公司批准进行的第三者交易），本公司保留对账户进行调查及审核等的相关权利，并从涉嫌账户中扣除由相关活动所赚取的盈利款项。本公司保留对相关账户进行必要更正或调整的权利。对于涉嫌从事操控的账户，本公司依据绝对酌情权，要求交易员进行干预、对下单进行核准以及或终止有关客户的账户。对于由套戥及或操控所产生的任何纠纷，本公司将依据绝对酌情权进行解决。本公司可依据酌情权决定向任何相关监管机构或执法机构报告有关事件，而不会就事件报告通知相关客户。于此处所陈述的任何行动或决议并不免除或损害本公司对客户和其雇员拥有之任何权利或赔偿。<br>
          (G)异常交易<br>
          为建立一个公平及公正的交易平台，我司将对客户交易账户在我司任何交易平台上出现的，包括但不限于以下异常交易活动做出进一步调查：<br>
          1. 于180秒或以内完成开仓平仓活动<br>
          2. 使用恶意程式交易或外挂软件进行交易<br>
          3. 同一账户、同一时间做出了大量交易<br>
          4. 使用同一装置并以多个不同账户交易<br>
          5. 透过影响国际市场价格导致该产品出现波动而非法获利<br>
          6. 以不同交易账户做不同方向交易对冲套利<br>
          7. 突然间的大量交易，例如从0.01手突然变成5-10手左右的交易<br>
          我司有权不定时依据风控情况对异常交易定义做出合理调整<br>
          公司特此郑重声明，绝不容许任何人士利用交易账户做出任何不正当交易，因上述（E）（F）（G）所述情形涉及的异常交易情况（包括但不限于），公司会对该交易账户依据官网【交易细则】中异常交易的处理方法对异常交易账户进行处理。
        </p>
        <strong>18.协议修改及终止</strong>
        <p>客户同意本公司可不时酌情决定修订、取消、或更替本协议之任何条款或增补任何新条款，本公司会把这些修改或变更在本公司网站www.golday.hk公布来通知客户。客户须不定时浏览有关条款之修改并同意受此约束。
          本协议将持续有效直至终止，而客户可在任何时候终止协议，只要届时客户没有持有未平仓现货贵金属头寸，不对本公司负有任何债务，且本公司实际收到终止协议的书面通知，或任何时候本公司向客户提出终止协议的书面通知，由发出通知当日收市随后第一个结算时间起开始生效，条件是如此终止将不影响任何之前签订的交易且不解除任何一方此协定项下的任何义务，或解除客户的任何债务的责任。
        </p>
        <strong>
          19.豁免或修订
        </strong>
        <p>
          本协议的任何条款不可被豁免或客户自行作出修订，除非豁免或修订是以书面的形式且由客户和本公司授权的授权人共同签字。在任何协议双方的交往过程中，或在任何情况下，本公司未能坚持其协议的权利均不可间接解释为本公司对该权利的放弃。任何口头协议或指示均不可被承认或执行。
        </p>
        <strong>20.抵押协议</strong>
        <p>
          客户的所有资金、货币及其它财产，如其被本公司在任何时候为客户持有，或在任何时候由本公司为任何目的（包括妥善保管）掌管或控制，此类财物将被本公司作为担保物，并可因客户对本公司的义务受制于普通留置权及对冲权，不论客户在本公司开立账户数目的多少。本公司可能在不通知客户的情况下行使其绝对酌情权，在任何时候将客户的所有资金、货币或其他财产投入或转向客户的任何账户。客户亦授权本公司以单独或者与其他客户的财产一起的形式，将客户作为保证金或担保物的任何财产以进行抵押、再抵押、投资或出借于本公司自身或其他方。此授权适用于所有本公司为客户开持的账户，并在客户全额付清所有债务之前、或本公司发出撤销通知之前有效。
        </p>
        <strong>21.权利转让</strong>
        <p>本公司可在未经客户事先同意或批准的情况下，将本协议之全部或部分之权利或义务授予任何人。</p>
        <strong>22.财务和信用状况</strong>
        <p>
          客户声明并保证其财务状况健全。客户在开始进行贵金属交易之前已非常仔细地考虑了贵金属交易的风险并明白客户现有资产中可为风险资本金的部分。客户保证及声明即使在贵金属交易中出现损失也不会对其生活方式带来任何改变。如果客户的财务状况发生变化以致降低该风险资本金，客户同意立即通知本公司。
          客户授权本公司，或其雇员以本公司的名义，调查客户的信用状况并查证及确定客户资料有关的合适的（所有）银行、金融机构和信用机构。客户进一步授权本公司调查其目前和过去的投资活动。此外，本公司将根据客户之信用状况，并有权要求客户提供所需证明（包括但不限于最近之税单、入息证明），以不时检讨客户的交易限额及或审批其提升交易限额之申请。
        </p>
        <strong>23.赔偿</strong>
        <p>
          客户同意，如果因为客户未能完全与及时地履行其承诺或因其声明或保证并不属实或正确，而给本公司带来任何债务、损失、损害、（成本或费用包括律师费），客户将必须对此向本公司作出所有赔偿，并使之不受损害及损失。客户同时同意立即支付给本公司在执行本协议任何条文或任何其他本公司与客户签订的协议所带来的损害、成本与费用（包括律师费）。此外，若损失来自（i）客户的行为：客户或授权人的行动、错误或遗漏；（ii）伪造签署：所有账户或本协议有关文档上的伪造签署或未获授权的签署；（iii）故障：客户或本公司的系统故障、设备故障或系统中断或运作失灵；（iv）延迟：本公司在执行客户向其发出之任何指示时发生之延迟、故障或错误；和（v）资料：从客户收到的不正确或不全的指示，本公司均不会承担任何责任或赔偿任何损失。
        </p>
        <strong>24.司法及仲裁</strong>
        <p>
          本协定及协定方的相应的权利与义务受香港特别行政区法律的管辖，并据此解释与执行。据此并没有和法律抵触而干预或妨碍条文之应用。若客户同意本仲裁协议，客户（i）放弃了在法院起诉本公司的权利并包括陪审权利在内；（ii）同意在任何根据本协议由客户或本公司提出仲裁的指控与反指控中受到仲裁的约束。客户不选择同意本仲裁协议条款约束亦可于本公司开立账户。<br>

          本协议连同开户申请书和有关附件构成本协议主题整体和全部内容。本协议将取代以前所有经双方签署或承诺的与本协议主题，杠杆式现货贵金属交易相关的书面或口头协议。<br>
          本人明白及确认本人已经细阅并接受此贵金属买卖条款及细则。</p>
      </div>
	         </div>
	    </div>
	</section>
	<!-- <section class="mask" v-show="apptxt">
	    <div class="content">
	        <div class="topTitles"> APP 相关</div> 
	        <span class="close js_close" @click="js_app()"> × </span>  
	        
	        <div class="scroll">
	        <p>APP名称：金盛贵金属</p>
	        <p>APP开发者：香港金盛贵金属有限公司</p>
	        <p>应用版本：安卓V3.3.0/IOS V2.4.0</p>
	        <p>更新时间：2021年1月25日</p>

	        <p>应用权限：</p>
	        <p>1、允许该应用通过全球定位系统(GPS)或网络位置信息源(例如基站和WLAN) 获取您的精确位置信息。您必须在设备上开启这些位置信息服务，应用才能获得位置信息。应用会使用此类服务确定您的位置，这可能会消耗更多电量。</p>

	        <p>2、允许该应用获取您的大致位置信息。这类位置信息来自于使用网络位置信息源(例如基站和WLAN)的位置信息服务。您必须在设备上开启这些位置信息服务，应用才能获得位置信息。应用会使用此类服务确定您的大概位置。</p>

	        <p>3、允许该应用使用麦克风录制音频。此权限可让该应用不经您的确认即可随时录制音频。</p>

	        <p>4、该应用访问设备的电话功能。此权限可让该应用确定本机号码和设备ID、是否正处于通话状态以及拨打的号码。</p>

	        <p>5、允许该应用读取存储卡中的内容。</p>

	        <p>6、允许该应用使用相机拍摄照片和视频。此权限可让该应用随时使用相机，而无需您确认。</p>

	        <p>7、允许该应用写入SD卡。</p>

	        <p>8、允许该应用访问后台位置，该权限仅会影响应用在后台运行时对位置信息的访问权限。常规权限允许访问网络允许该应用访问网络连接，可能产生GPRS流量。</p>

	        <p>9、允许该应用更改网络连接的状态。</p>

	        <p>10、允许该应用创建网络套接字和使用自定义网络协议。浏览器和其他某些应用提供了向互联网发送数据的途径，因此应用无需该权限即可向互联网发送数据。</p>

	        <p>11、允许该应用读写系统的设置数据。恶意应用可能会破坏您的系统配置。</p>

	        <p>12、允许该应用请求安装文件包。</p>

	        <p>13、允许该应用使用其他的位置信息提供程序命令。此权限使该应用可以干扰GPS或其他位置信息源的运作。</p>

	        <p>14、允许该应用修改全局音频设置，例如音量和用于输出的扬声器。</p>

	        <p>15、允许该应用阻止手机进入休眠状态。</p>

	        <p>隐私政策：</p>
	        <p>交易商根据《个人资料(隐私条例》来保护客户的个人资料隐私。在交易商使用客户资料以提供其最佳之服务时，亦会高度关注对于客户资料使用之安排。交易商会根据香港特别行政区法例《个人资料(隐私)条例》之规定，力求完全符合个人资料保证要求。为此，交易商会确保其雇员遵守法例规定的保安和保密严谨标准。</p>

	        <p>1、为保障客户正常使用服务，维护服务的正常运行，改进及优化服务体验以及保障账户安全，可能需要客户授权使用如下个人权限： 实名认证：确保客户信息准确无误；相机/相册：发送图片，选取图片上传，存储照片，扫一扫，用于反馈意见和个人信息审核时使用； 银行卡识别：为保障客户资金安全，需进行银行卡审核； 用户地址：主要用于发放实物奖励。</p>

	        <p>2、交易商收集的各项个人资料，只供应业务运作及其他有关活动之用。</p>

	        <p>3、关于使用Cookies技术：交易商可能会在客户及存款交易商的电脑设定cookies，可能会于交易商的产品和服务中使用cookies来分析客户在交易商网站的浏览行为，以协助交易商更好的了解客户需求及提供更好的服务方式，但对于收集得来和共用的资料是不具姓名及无法被个别识别的。</p>

	        <p>4、信息储存：交易商会按照法律法规规定，将收集的用户信息存储于中国香港服务器。一般而言，我们仅为实现对客服务所必需的时间保留客户的用户信息。</p>

	        <p>5、信息安全保护：交易商致力于使用防火墙、密码和个人身份证号码认证系统和操控机制来控制未授权的系统进入和存储资料，或使用其他资料保障工具确保网站安全及符合业界标准。</p>

	        <p>6、交易商不会将客户个人资料用于用户画像、个性化展示，也不会收集关于您设备上安装的其他APP信息。交易商使用客户的用户信息，超出了与收集时声称的目的及具有直接或合理关联的范围，将会在使用用户信息前，再次告知并征求客户的明示同意（通过主动点击“确认”做出直接性动作） 。</p>

	        <p>7、交易商会将客户个人资料保密储存，防止其个人资料被盗用，未达到隐私保护之最佳效果，除符合本款第五、第七条之规定外，客户充分理解交易商不会向客户本人以外的任何主体提供客户的资料、信息，即使该主体声称其为授权。</p>
	        </div> 
	    </div>
	</section> -->
	</footer>
</template>

<script>
export default {
   name: 'foot',
   data () {
	    return {
	        msg: '金盛贵金属官网_正规香港贵金属交易平台', 
	        yingyong:false,
	        yingsi:false,
	        apptxt:false,
			    xieyi:false
	    }
  	},
  	methods:{
	  	js_yingyong(){
			this.yingyong = !this.yingyong;
		},
		js_yingsi(){
			this.yingsi = !this.yingsi;
		},
		js_xieyi(){
			this.xieyi = !this.xieyi;
		},
		js_app(){
			this.apptxt = !this.apptxt;
		}
  	}
  	

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.scroll p,.scroll h1, .scroll h2, .scroll h3,.scroll strong{
		font-size: .24rem;
		text-align: left;
	}
	 .scroll h2, .scroll h3{padding-left:.3rem;}
	.foot{
		width:100%;
		padding:.4rem 0 2.1rem ;
		color: #333333;
		background:#42403f;
		line-height: 0.48rem; 
		text-align: center;
	}		
	.appTxt{
		font-size: inherit;
		font-weight: normal;
	}
	.p1{
		font-size: 0.24rem; 
		color: #c9c9c9;  
	}
	.p2{
		font-size:0.36rem;
		color: #c9c9c9;
	}
	.p3{
		font-size: 0.24rem; 
		line-height: 0.4rem; 
		color: #999;
	}
	.line{
		width:6.9rem;
		height:1px;
		margin:.2rem auto .2rem;
		background:#d4d4d4;
	}
	.mt15{
		margin-top:.15rem;
	}

	.mlr{
		margin:0 .1rem;
		text-decoration: underline;
	}
	.mask{
        width:100%;
        height: 100%;
        background:rgba(0,0,0,.3);
        position: fixed;
        top:0;
        left: 0;
        
        z-index: 1000;
    }
    .content{
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        border-radius: 7px;
        background: #fff;
        width:6.5rem;
        height: 8rem;
    }  
    .content .topTitles{
        width: 100%;
        height: .7rem;
        line-height: .7rem;
        text-align: center;
        color:#fff;
        font-size: .32rem;
        background-color: #ff5555;
        border-radius:3px 0px 0px;
         margin-bottom:.3rem;
    }
    .content .scroll{
    	width: 100%;
    	height: 6.6rem;
    	overflow-y: scroll;
    }
    .content .close{
        width: .35rem;
        height: .35rem;
        line-height: .32rem;
        color:#fff;
        font-size: .26rem;
        text-align: center;
        position: absolute;
        top:.08rem;
        right: .08rem;
        border: solid 1px #ffffff;
        border-radius: 30px;
        cursor: pointer;
    }
    
    .content p{
        font-size: .26rem;
        text-align: left;
	    line-height: .4rem;
	    color: #333;
	    width: 92%;
	    margin: .08rem auto;
    }
    .content .incent{
        text-indent:.4rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue